import React from "react";
import moment from "moment";

const ProfileHeader = ({ user }) => {
  const memberSince = user?.created_at?.seconds
    ? moment.unix(user.created_at.seconds).format("DD MMM YYYY")
    : "N/A";

  return (
    <div className="saas-hero-card">
      <div className="hero-content">
        <div className="avatar-wrapper">
          <img
            src={user?.player_image?.url || "https://via.placeholder.com/150"}
            alt="Profile Avatar"
            className="profile-avatar"
          />
        </div>
        <div className="hero-info">
          <div className="name-row">
            <h2>{user?.first_name} {user?.last_name}</h2>
            <i className="fas fa-check-circle verified-badge" title="Verified Athlete"></i>
          </div>
          <div className="sport-title">{user?.sport || "Athlete"}</div>
          <div className="location-row">
            <i className="fas fa-map-marker-alt"></i>
            <span>{user?.city ? `${user.city}, ` : ""}{user?.state || "USA"}</span>
          </div>

          <div className="hero-quick-stats">
            <div className="quick-stat-badge">
              <i className="fas fa-id-badge"></i>
              Athlete ID: <span>{user?.athleteID || "N/A"}</span>
            </div>
            <div className="quick-stat-badge">
              <i className="fas fa-running"></i>
              Sport: <span>{user?.sport || "N/A"}</span>
            </div>
            <div className="quick-stat-badge">
              <i className="fas fa-graduation-cap"></i>
              Level: <span>{user?.sportLevel || "N/A"}</span>
            </div>
            <div className="quick-stat-badge">
              <i className="fas fa-calendar-alt"></i>
              Member Since: <span>{memberSince}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
